var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 0H3.33333C1.11111 0 0 1.14286 0 3.42857V12.5714C0 14.8571 1.11111 16 3.33333 16H16.6667C18.8889 16 20 14.8571 20 12.5714V3.42857C20 1.14286 18.8889 0 16.6667 0ZM3.33333 9.14286C2.71944 9.14286 2.22222 8.63143 2.22222 8C2.22222 7.36857 2.71944 6.85714 3.33333 6.85714C3.94722 6.85714 4.44444 7.36857 4.44444 8C4.44444 8.63143 3.94722 9.14 3.33333 9.14286ZM10 11.4286C8.15833 11.4286 6.66667 9.89429 6.66667 8C6.66667 6.10571 8.15833 4.57143 10 4.57143C11.8417 4.57143 13.3333 6.10571 13.3333 8C13.3333 9.89143 11.8472 11.4257 10.0083 11.4286H10ZM16.6667 9.14286C16.0528 9.14286 15.5556 8.63143 15.5556 8C15.5556 7.36857 16.0528 6.85714 16.6667 6.85714C17.2806 6.85714 17.7778 7.36857 17.7778 8C17.7778 8.63143 17.2806 9.14 16.6667 9.14286Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosCash);
export default __webpack_public_path__ + "static/media/pos-cash.0ab0f3b88886b16276590f34f6c77e47.svg";
export { ForwardRef as ReactComponent };